export const COLUMNS = [
  { label: 'Acquisition Channel', key: 'name' },
  { label: '% of clients', key: 'newCustomersPercentage', type: 'percentage', valueFormat: Number },
  { label: '# of clients', key: 'totalCustomers', valueFormat: Number },
];

// Actions
export const CLEAR_ITEMS = 'marketingLeads/CLEAR_ITEMS';
export const FETCH_ITEMS = 'marketingLeads/FETCH_ITEMS';
export const FETCH_ITEM = 'marketingLeads/FETCH_ITEM';
export const UPDATE_ITEM = 'marketingLeads/UPDATE_ITEM';
export const ADD_ITEM = 'marketingLeads/ADD_ITEM';
export const DELETE_ITEM = 'marketingLeads/DELETE_ITEM';
